import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UpdatewifidetailsRoutingModule } from './updatewifidetails-routing.module';
import { UpdatewifidetailsComponent } from './updatewifidetails.component';
import { SharedModule } from 'app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [UpdatewifidetailsComponent],
  imports: [
    CommonModule,
    NgbModule,
    UpdatewifidetailsRoutingModule,
    CommonModule,      
        
        SharedModule,
       
        ReactiveFormsModule
  ]
})
export class UpdatewifidetailsModule { }
